(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.sl-buy').forEach(function (root) {
      var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      var fmt = JSON.parse(root.querySelector('[data-money-format]').textContent);
      var form = root.querySelector('form');
      var idInput = root.querySelector('[data-variant-id]');
      var options = Array.prototype.slice.call(root.querySelectorAll('.sl-option'));
      var buyNow = root.querySelector('[data-buy-now]');
      var addBtn = root.querySelector('button[name="add"]');

      function money(cents) {
        var n = (cents / 100);
        var amount = Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',');
        return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
      }
      function selected() {
        return options.map(function (fs) {
          var on = fs.querySelector('[aria-pressed="true"]');
          return on ? on.getAttribute('data-value') : null;
        });
      }
      function findVariant(sel) {
        return variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || sel[i] === o; }); });
      }
      function update() {
        var v = findVariant(selected());
        if (!v) return;
        idInput.value = v.id;
        root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = money(v.price); });
        [buyNow, addBtn].forEach(function (b) { if (b) b.disabled = !v.available; });
        if (addBtn) addBtn.querySelector('span').textContent = v.available ? 'Add to cart' : 'Sold out';
        var slide = root.querySelector('[data-variant-slide]');
        var img = root.querySelector('[data-variant-slide] img');
        if (v.featured_media && v.featured_media.preview_image && img) {
          var src = v.featured_media.preview_image.src;
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1100';
          img.removeAttribute('srcset');
          slide.hidden = false;
          root.querySelector('[data-gallery]').scrollTo({ left: 0, behavior: 'smooth' });
        }
        var url = new URL(window.location.href);
        if (url.pathname.indexOf('/products/') === 0) { url.searchParams.set('variant', v.id); history.replaceState(null, '', url); }
      }
      options.forEach(function (fs) {
        fs.addEventListener('click', function (e) {
          var b = e.target.closest('.sl-pill');
          if (!b) return;
          fs.querySelectorAll('.sl-pill').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          update();
        });
      });

      var nameIn = root.querySelector('[data-name-input]');
      var phoneIn = root.querySelector('[data-phone-input]');
      var plateName = root.querySelector('[data-plate-name]');
      var platePhone = root.querySelector('[data-plate-phone]');
      var fallback = plateName ? plateName.textContent : '';
      if (nameIn) nameIn.addEventListener('input', function () { plateName.textContent = nameIn.value.trim() || fallback; });
      if (phoneIn) phoneIn.addEventListener('input', function () { platePhone.textContent = phoneIn.value.trim(); });

      // Buy now: same validation, add this line, then the same tab goes to checkout.
      if (buyNow) buyNow.addEventListener('click', function () {
        if (!form.reportValidity()) return;
        buyNow.setAttribute('aria-disabled', 'true');
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status) { buyNow.removeAttribute('aria-disabled'); alert(res.description || res.message || 'Could not add it to the cart.'); return; }
          window.location.assign('/checkout');
        }).catch(function () { buyNow.removeAttribute('aria-disabled'); });
      });

      // Gallery dots
      var track = root.querySelector('[data-gallery]');
      var dots = root.querySelector('[data-dots]');
      function slides() { return Array.prototype.filter.call(track.children, function (s) { return !s.hidden; }); }
      function drawDots() {
        var n = slides().length, i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.innerHTML = '';
        for (var k = 0; k < n; k++) { var d = document.createElement('span'); if (k === i) d.className = 'is-on'; dots.appendChild(d); }
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(drawDots); }, { passive: true });
      drawDots();

      // Sticky bar on phones once the hero has scrolled away and while the form is off screen.
      var sticky = root.querySelector('[data-sticky]');
      var hero = document.querySelector('.sl-hero');
      var details = root.querySelector('.sl-details');
      if (sticky && 'IntersectionObserver' in window) {
        var heroVisible = !!hero, formVisible = false;
        var sync = function () { sticky.hidden = heroVisible || formVisible; };
        if (hero) new IntersectionObserver(function (e) { heroVisible = e[0].isIntersecting; sync(); }).observe(hero);
        new IntersectionObserver(function (e) { formVisible = e[0].isIntersecting; sync(); }, { threshold: 0.05 }).observe(details);
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { threshold: 0.2 });
      document.querySelectorAll('.sl-reveal').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.sl-reveal').forEach(function (el) { el.classList.add('is-in'); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
